import React from 'react';
import ContentSections from '../base/ContentSections';
import GeneralSection from './GeneralSection';
import ActivePeriodSection from './ActivePeriodSection';
import KeyVisualSection from './KeyVisualSection';
import MissionCardStyleSection from './MissionCardStyleSection';

function CreateGreetingSectionStepOne() {

  const sections = [
    <GeneralSection />,
    <KeyVisualSection />,
    <MissionCardStyleSection />,
    <ActivePeriodSection />,
  ];

  return (
    <>
      <ContentSections sections={sections} hidePreview={true} />
    </>
  );
}

export default CreateGreetingSectionStepOne;
